const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

/**
 * User-facing reason a file can't be uploaded as an image, or null when it can.
 * Callers that crop and resize before uploading pass `Infinity`: raw phone photos often exceed 5 MB.
 */
export function imageFileProblem(file: File, maxSize = MAX_IMAGE_FILE_SIZE): string | null {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    const extension = file.name.split('.').pop()?.toUpperCase() || file.type;
    return `Unsupported format (${extension}). Please upload a JPEG, PNG, GIF, or WebP image.`;
  }
  if (file.size > maxSize) {
    const sizeMegabytes = (file.size / 1024 / 1024).toFixed(1);
    return `File too large (${sizeMegabytes} MB). Max size is 5 MB.`;
  }
  return null;
}

/** The cropper hands back base64; every upload endpoint wants a blob. */
export function dataUriToBlob(dataUri: string): Blob {
  const [header, data] = dataUri.split(',');
  const byteString = header.includes('base64') ? atob(data) : decodeURI(data);
  const mimeString = header.split(':')[1].split(';')[0];
  const bytes = new Uint8Array(byteString.length);
  for (let index = 0; index < byteString.length; index++) {
    bytes[index] = byteString.charCodeAt(index);
  }
  return new Blob([bytes], { type: mimeString });
}
